module.exports = __webpack_public_path__ + "static/img/portal-step2-stgregs.6b35e80.png";


//////////////////
// WEBPACK FOOTER
// ./static/enrol/portal-step2-stgregs.png
// module id = TAe/
// module chunks = 170